import type { Credential } from './Credential'

export type StoredCredentialResponse = {
  credential: Credential
};